import { extend, stringValue } from 'vega-util';
import { Bottom, Left, Right, Top } from './constants';
import { encoder } from '../encode/util';
import { isSignal } from '../../util';
var isX = function isX(orient) {
  return orient === Bottom || orient === Top;
};

// get sign coefficient based on axis orient
export var getSign = function getSign(orient, a, b) {
  return isSignal(orient) ? ifLeftTopExpr(orient.signal, a, b) : orient === Left || orient === Top ? a : b;
};

// condition on axis x-direction
export var ifX = function ifX(orient, a, b) {
  return isSignal(orient) ? ifXEnc(orient.signal, a, b) : isX(orient) ? a : b;
};

// condition on axis y-direction
export var ifY = function ifY(orient, a, b) {
  return isSignal(orient) ? ifYEnc(orient.signal, a, b) : isX(orient) ? b : a;
};
export var ifTop = function ifTop(orient, a, b) {
  return isSignal(orient) ? ifTopExpr(orient.signal, a, b) : orient === Top ? {
    value: a
  } : {
    value: b
  };
};
export var ifRight = function ifRight(orient, a, b) {
  return isSignal(orient) ? ifRightExpr(orient.signal, a, b) : orient === Right ? {
    value: a
  } : {
    value: b
  };
};
var ifXEnc = function ifXEnc($orient, a, b) {
  return ifEnc("".concat($orient, " === '").concat(Top, "' || ").concat($orient, " === '").concat(Bottom, "'"), a, b);
};
var ifYEnc = function ifYEnc($orient, a, b) {
  return ifEnc("".concat($orient, " !== '").concat(Top, "' && ").concat($orient, " !== '").concat(Bottom, "'"), a, b);
};
var ifLeftTopExpr = function ifLeftTopExpr($orient, a, b) {
  return ifExpr("".concat($orient, " === '").concat(Left, "' || ").concat($orient, " === '").concat(Top, "'"), a, b);
};
var ifTopExpr = function ifTopExpr($orient, a, b) {
  return ifExpr("".concat($orient, " === '").concat(Top, "'"), a, b);
};
var ifRightExpr = function ifRightExpr($orient, a, b) {
  return ifExpr("".concat($orient, " === '").concat(Right, "'"), a, b);
};
var ifEnc = function ifEnc(test, a, b) {
  // ensure inputs are encoder objects (or null)
  a = a != null ? encoder(a) : a;
  b = b != null ? encoder(b) : b;
  if (isSimple(a) && isSimple(b)) {
    // if possible generate simple signal expression
    a = a ? a.signal || stringValue(a.value) : null;
    b = b ? b.signal || stringValue(b.value) : null;
    return {
      signal: "".concat(test, " ? (").concat(a, ") : (").concat(b, ")")
    };
  } else {
    // otherwise generate rule set
    return [extend({
      test: test
    }, a)].concat(b || []);
  }
};
var isSimple = function isSimple(enc) {
  return enc == null || Object.keys(enc).length === 1;
};
var ifExpr = function ifExpr(test, a, b) {
  return {
    signal: "".concat(test, " ? (").concat(toExpr(a), ") : (").concat(toExpr(b), ")")
  };
};
export var ifOrient = function ifOrient($orient, t, b, l, r) {
  return {
    signal: (l != null ? "".concat($orient, " === '").concat(Left, "' ? (").concat(toExpr(l), ") : ") : '') + (b != null ? "".concat($orient, " === '").concat(Bottom, "' ? (").concat(toExpr(b), ") : ") : '') + (r != null ? "".concat($orient, " === '").concat(Right, "' ? (").concat(toExpr(r), ") : ") : '') + (t != null ? "".concat($orient, " === '").concat(Top, "' ? (").concat(toExpr(t), ") : ") : '') + '(null)'
  };
};
var toExpr = function toExpr(v) {
  return isSignal(v) ? v.signal : v == null ? null : stringValue(v);
};
export var mult = function mult(sign, value) {
  return value === 0 ? 0 : isSignal(sign) ? {
    signal: "(".concat(sign.signal, ") * ").concat(value)
  } : {
    value: sign * value
  };
};
export var patch = function patch(value, base) {
  var s = value.signal;
  return s && s.endsWith('(null)') ? {
    signal: s.slice(0, -6) + base.signal
  } : value;
};